import { render, staticRenderFns } from "./CircleXmarkSolid.vue?vue&type=template&id=1fede436"
import script from "./CircleXmarkSolid.vue?vue&type=script&lang=ts"
export * from "./CircleXmarkSolid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports